import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useInstanceId } from 'shared/src/hooks';
import { deleteAddress } from 'mypage/src/api/addressService';
import type { Address } from 'mypage/src/api/addressService';
import { queryKey } from '../../../constant/queryKey';

/**
 * 배송지 삭제.
 * iOS 패턴과 동일하게 응답 성공 후 로컬 캐시에서만 제거 (refetch 없음).
 */
export const useDeleteAddress = () => {
  const client = useQueryClient();
  const instanceId = useInstanceId();
  return useMutation({
    mutationFn: deleteAddress,
    onSuccess: (_, { sno }) => {
      client.setQueryData<{ addresses: Address[] }>(
        queryKey.addresses(instanceId),
        old =>
          old ? { addresses: old.addresses.filter(a => a.sno !== sno) } : old,
      );
    },
  });
};
